import { render, staticRenderFns } from "./AdsetTableOfPrice.vue?vue&type=template&id=9ed6cd1a&"
import script from "./AdsetTableOfPrice.vue?vue&type=script&lang=ts&"
export * from "./AdsetTableOfPrice.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports